// extracted by mini-css-extract-plugin
export default {"nutrientGoal":"d0GdcQwSEZVOSLnhraiX"};